import React from "react";

// loading assets
import Introduction from "./about_data/Introduction";

const About = () => {
  return (
    <div className="main-background">
      <Introduction />
    </div>
  );
};

export default About;
